import React from 'react';
import styles from './DashboardMobileHeader.module.scss';
import { IconMenu, IconNotification, IconUser } from '@justeattakeaway/pie-icons-react';
import { PIEIconButton } from '@src/shared/components/PIEIconButton';
import { IHeaderVariantProps } from '../..';
import { Badge } from 'snacks-design-system';
import PWAAppScreens from '@src/shared/components/PWAAppScreens';
import { useOnboardingStore } from '@src/shared/store/onboarding/onboarding-store';
const DashoardMobileHeader = ({
  onShowMenu,
  onShowNotificationMenu,
  onShowUserMenu,
  notificationCount,
  loading,
}: IHeaderVariantProps) => {
  const { onboardingActive } = useOnboardingStore();
  return (
    <>
      {!onboardingActive && <PWAAppScreens />}
      <div className={styles.dashboardMobileHeader}>
        <PIEIconButton
          onClick={onShowMenu}
          className={styles.headerMenuItem}
          icon={<IconMenu size="xs" />}
        />
        <PIEIconButton
          onClick={onShowNotificationMenu}
          className={styles.headerMenuItem}
          isLoading={loading}
          icon={
            <>
              <IconNotification size="m" />
              {notificationCount > 0 && (
                <Badge mode="primary" align="t-l">
                  {notificationCount}
                </Badge>
              )}
            </>
          }
        />
        <PIEIconButton
          qaSelector={'mobile-header-show-user-menu-button'}
          onClick={onShowUserMenu}
          className={styles.headerMenuItem}
          icon={<IconUser size="xs" />}
        />
      </div>
    </>
  );
};

export default DashoardMobileHeader;
